class L10n {
  constructor(translates) {
    const fallback = 'en';

    if (window.navigator.languages) {
      const [lan] = window.navigator.languages;
      this.lan = lan;
    } else {
      this.lan = window.navigator.userLanguage || window.navigator.language;
    }

    if (!Object.prototype.hasOwnProperty.call(translates, this.lan)) {
      this.lan = fallback;
    }

    this.strings = translates;
  }

  gettext(key, param) {
    return this.strings[this.lan][key](param);
  }
}

export default L10n;
